import { render, staticRenderFns } from "./footer-for-empty.vue?vue&type=template&id=6f4d5151&scoped=true"
import script from "./footer-for-empty.vue?vue&type=script&lang=js"
export * from "./footer-for-empty.vue?vue&type=script&lang=js"
import style0 from "./footer-for-empty.vue?vue&type=style&index=0&id=6f4d5151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d5151",
  null
  
)

export default component.exports